import { auth } from "../firebase";

const baseURL = `${process.env.REACT_APP_API_URL}`;

export const getRaw = (url) =>
    auth.currentUser.getIdToken(false).then(async (token) => {
        const response = await fetch(`${baseURL}${url}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response;
    });

export const get = (url) =>
  auth.currentUser.getIdToken(false).then(async (token) => {
    const response = await fetch(`${baseURL}${url}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((res) => res.json());
    return response;
  });

export const post = (url, body) =>
  auth.currentUser.getIdToken(false).then(async (token) => {
    const response = await fetch(`${baseURL}${url}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body,
    }).then(async (res) => {
        if (res.status >= 400 && res.status < 600) {
            let message = "something went wrong";
            try {
                const errorBody = await res.json();
                message = errorBody?.error?.message || errorBody?.message || message;
            } catch (e) {
                // body was empty or not JSON - keep the generic message
            }
            throw new Error(message);
        }
        return res.json();
    });
    return response;
  });

export const put = (url, body) =>
  auth.currentUser.getIdToken(false).then(async (token) => {
    const response = await fetch(`${baseURL}${url}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body,
    }).then((res) => res.json());
    return response;
  });

export const deleteItem = (url, body) =>
  auth.currentUser.getIdToken(false).then(async (token) => {
    const response = await fetch(`${baseURL}${url}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((res) => res.json());
    return response;
  });

const api = {
  get: get,
  post: post,
  put: put,
  delete: deleteItem,
};

export default api;
